// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/home/ec2-user/api/wtl-project-starter/build.c9fb5ff2-95d1-411d-90b7-0fe84cf3c482/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/home/ec2-user/api/wtl-project-starter/build.c9fb5ff2-95d1-411d-90b7-0fe84cf3c482/.cache/data.json")

